import React from 'react';
import { IAccount } from '../../models/company-account';

interface IAccountItemProps {
    account: IAccount;
}

const AccountItem = ({ account }: IAccountItemProps) => {
    return (
        <div className="col-md-4">
            <div className="row">
                <div
                    className="col-md-12"
                    style={{ textTransform: 'uppercase' }}
                >
                    {account.fullAccountNumber}: {account.partyName}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">{account.street1}</div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {account.city},&nbsp;{account.state}&nbsp;
                    {account.postalCode}
                </div>
            </div>
        </div>
    );
};

export default AccountItem;
